import styled from 'styled-components';

export const SpaceBetween = styled.div<{ direction?: 'row' | 'column' }>`
    display: flex;
    flex-direction: ${({ direction = 'row' }) => direction};
    justify-content: space-between;
`;
